import React from 'react';
import { Route } from 'react-router';

import LandlordApplications from 'components/landlord_app/applications/LandlordApplications';
import InviteLeadToApply from 'components/landlord_app/application_management/InviteLeadToApply';
import ApplicationOverview from 'components/landlord_app/application_management/ApplicationOverview';
import ApplicationsTable from 'components/landlord_app/application_management/ApplicationsTable';

import { featureEnabled } from 'helpers/ToggleBot';
import LandlordPolicies from 'components/landlord_app/policies/LandlordPolicies';

const whichApplicationDrawerToRender = (_, callback) => {
  const ComponentToRender = featureEnabled('application-management')
    ? ApplicationOverview
    : LandlordApplications;
  callback(null, ComponentToRender);
};

const whichTableToRender = (_, callback) => {
  const ComponentToRender = featureEnabled('application-management')
    ? ApplicationsTable
    : LandlordApplications;
  callback(null, ComponentToRender);
};

const ApplicationManagementRoutes = (authenticateLandlord) => {
  return (
    <React.Fragment>
      <Route path="applications" getComponent={whichTableToRender} onEnter={authenticateLandlord} />

      <Route path="policies" component={LandlordPolicies} onEnter={authenticateLandlord} />

      <Route
        path="applications/create_new_application"
        component={InviteLeadToApply}
        onEnter={authenticateLandlord}
      />

      <Route
        path="applications/:applicationID(/:tab)"
        getComponent={whichApplicationDrawerToRender}
        onEnter={authenticateLandlord}
      />
    </React.Fragment>
  );
};

export default ApplicationManagementRoutes;
